module.exports = __webpack_public_path__ + "media/images/element/instructor-course-ce5951459df1bfeb6683a538085504b1.svg";